// extracted by mini-css-extract-plugin
export default {"cls1":"u3YLxFPx71pbOpHNl9a0","cls2":"vGyUbIjaGeCIMAgRy2Me u3YLxFPx71pbOpHNl9a0","isPhone":"rVDABU0M08OxBtMMGVSJ"};